import Settings from '../olr-common/Settings';

export default function ReportService($http) {
  let url = Settings.backendEnv + "/api/v1/reports";

  this.getMarkReports = function(reqObj) {
    var reqUrl = url+ "/getExamDetails";
    var req = {
      method:  "POST",
      url:    reqUrl,
      data:   reqObj
    };

    return $http(req);
  };

  this.getAllClassRooms = function(){
    var reqUrl = url + "/getClassRooms";
    return $http({method: 'GET',url: reqUrl});
  };

  this.getAllExamsOfClass = function(classRoomId){
    var reqUrl = url + "/getExams/" + classRoomId;
    return $http({method: 'GET',url: reqUrl});
  };

  this.deleteTodo = function(todoObj) {
    var req = {
      method: "DELETE",
      url:    url + "/" + todoObj.todoId
    };

    return $http(req);
  };
}


/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-api/ReportService.js
 **/